import { company } from '@/mocks/site';
import { buildWhatsAppUrl } from '@/hooks/whatsappLink';

const whatsappUrl = buildWhatsAppUrl([
  'Bonjour SGSCTIC, je souhaite des informations sur vos prestations industrielles.',
]);

export default function FloatingContact() {
  return (
    <div className="fixed bottom-5 right-4 z-40 flex flex-col items-end gap-2.5 md:bottom-8 md:right-8 md:gap-3">
      <a
        href={whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Écrire à SGSCTIC sur WhatsApp"
        title="Écrire sur WhatsApp"
        className="group flex cursor-pointer items-center gap-2 rounded-full bg-accent-500 py-2 pl-2 pr-2 text-foreground-950 transition-all duration-300 hover:bg-accent-400 md:py-2.5 md:pl-2.5 md:pr-3"
      >
        <span className="flex h-9 w-9 items-center justify-center rounded-full bg-foreground-950/12">
          <i className="ri-whatsapp-line text-lg" />
        </span>
        <span className="max-w-0 overflow-hidden whitespace-nowrap text-[11px] font-semibold uppercase tracking-[0.12em] transition-all duration-500 group-hover:max-w-[150px] group-hover:pr-1">
          WhatsApp
        </span>
      </a>

      <a
        href={company.phoneHref}
        aria-label="Appeler SGSCTIC"
        title="Appeler l'atelier"
        className="group flex cursor-pointer items-center gap-2 rounded-full bg-foreground-950 py-2 pl-2 pr-2 text-background-50 transition-all duration-300 hover:bg-primary-600 md:py-2.5 md:pl-2.5 md:pr-3"
      >
        <span className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50/12">
          <i className="ri-phone-fill text-base" />
        </span>
        <span className="max-w-0 overflow-hidden whitespace-nowrap text-[11px] font-semibold uppercase tracking-[0.12em] transition-all duration-500 group-hover:max-w-[150px] group-hover:pr-1">
          Appelez-nous
        </span>
      </a>
    </div>
  );
}